import "core-js/modules/es.number.constructor.js";
import { isNull } from 'lodash-es';
import { getCountryFromUrl } from '~/core/i18n/functions';
import { COUNTRY_CODE } from '~/core/i18n/constants/countryCode';
var initYandexMetrika = function initYandexMetrika() {
  var _process$env$ymCounte, _process$env$ymCounte2, _process$env$ymCounte3, _process$env$ymCounte4;
  (function (m, e, t, r, i, k, a) {
    // @ts-ignore
    m[i] = m[i] || function () {
      // @ts-ignore
      // eslint-disable-next-line prefer-rest-params
      (m[i].a = m[i].a || []).push(arguments);
    };
    // @ts-ignore
    m[i].l = 1 * new Date();
    // @ts-ignore
    // eslint-disable-next-line no-unused-expressions,no-sequences
    k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');
  var _useRequestURL = useRequestURL(),
    hostname = _useRequestURL.hostname;
  var country = getCountryFromUrl({
    hostname: hostname
  });
  var counterId = null;
  switch (country) {
    case COUNTRY_CODE.RU:
      counterId = (_process$env$ymCounte = process.env.ymCounterIdRu) !== null && _process$env$ymCounte !== void 0 ? _process$env$ymCounte : '';
      break;
    case COUNTRY_CODE.KZ:
      counterId = (_process$env$ymCounte2 = process.env.ymCounterIdKz) !== null && _process$env$ymCounte2 !== void 0 ? _process$env$ymCounte2 : '';
      break;
    case COUNTRY_CODE.BY:
      counterId = (_process$env$ymCounte3 = process.env.ymCounterIdBy) !== null && _process$env$ymCounte3 !== void 0 ? _process$env$ymCounte3 : '';
      break;
    case COUNTRY_CODE.KG:
      counterId = (_process$env$ymCounte4 = process.env.ymCounterIdKg) !== null && _process$env$ymCounte4 !== void 0 ? _process$env$ymCounte4 : '';
      break;
  }
  if (!counterId) {
    return null;
  }
  var numericCounter = Number(counterId);
  window.ym(numericCounter, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true
  });
  window.__YM_COUNTER_ID__ = numericCounter;
  return numericCounter;
};
export default defineNuxtPlugin(function () {
  var $router = useRouter();
  var numericCounter = initYandexMetrika();
  if (isNull(numericCounter)) {
    return;
  }
  $router.afterEach(function (to, from) {
    var baseUrl = location.origin;
    window.ym(numericCounter, 'hit', baseUrl + to.fullPath, {
      referer: baseUrl + from.fullPath
    });
  });
});